import React from 'react'
import { LikeIcon } from '../../../assets/icons';
import circle from '../../../assets/img/circulogris.png';
import './ImageDescription.css'
import showIcon from './utils';

const ImageDescription = ({
    onClick = () => { },
    description,
    icon,
    type = '',
    shouldDscriptionEllipsis = true,
    srcImage,
}) => {
    return (
        <div className={`content-image-name ${type}`} onClick={onClick}>
            <div className='notification-icon-content'>{showIcon(icon)} </div>
            <div className="content-name-description">
                <div className={shouldDscriptionEllipsis ? `description-image-name` : `description-image-name-overflow`}>{description}</div>
            </div>
        </div>
    )
}

export default ImageDescription
